import React, { useCallback, useContext, useEffect, useState } from "react";

import { DContext } from "../../context/Datacontext";
import { createDepartment } from "../../services/coures/department";
import { createCourse } from "../../services/coures/createCourse";
import { fetchCourseManageData } from "../../services/coures/fetchCourseManageData";
import { DepartmentList } from "./DepartmentList";
import { CourseList } from "./CourseList";
import { Pagination } from "../../utils/Pagination";

export const CourseManage = () => {

    const { BeURL } = useContext(DContext);
    const [activeTab, setActiveTab] = useState("department");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [courses, setCourses] = useState([]);
    const [showDeptPopup, setShowDeptPopup] = useState(false);
    const [showCoursePopup, setShowCoursePopup] = useState(false);
    const [department, setDepartment] = useState("");
    const [courseName, setCourseName] = useState("");
    const [departments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);


    /* ================= LOAD TABLE ================= */



    const loadData = useCallback(async () => {
        try {
            setLoading(true);
            const res = await fetchCourseManageData({
                BeURL,
                type: activeTab,
                page,
                limit,
            });

            if (res?.success) {
                setCourses(res.courses || []);
                setTotalPages(res.totalPages || 1);
                setTotal(res.total || 0);
            }

        } catch (err) {
            console.log("Error in fetch Department");
        }

        setLoading(false);
    },[BeURL,activeTab,page,limit]);


    useEffect(() => {
        loadData();
    }, [loadData]);


    const handleCreateDepartment = async () => {

        if (!department.trim()) return;

        try {

            setLoading(true);

            const res = await createDepartment({
                BeURL,
                department: department.trim(),
            });

            if (res?.success) {

                alert("Department created");

                setDepartment("");
                setShowDeptPopup(false);

                if (activeTab === "department") loadData();
            }

        } catch (err) {
            console.log(err);
        }

        setLoading(false);
    };


    /* ================= CREATE COURSE ================= */

    const handleCreateCourse = async () => {

        if (!selectedDepartment) {
            alert("Select department");
            return;
        }

        if (!courseName.trim()) {
            alert("Enter course name");
            return;
        }

        try {

            setLoading(true);

            const res = await createCourse({
                BeURL,
                departmentId: selectedDepartment._id,
                courseName: courseName.trim(),
            });

            if (res?.success) {

                const newCourse = res.course;

                // update departments
                setSelectedDepartment(prev =>
                    prev
                        ? {
                            ...prev,
                            courses: [...(Array.isArray(prev.courses) ? prev.courses : []), newCourse]
                        }
                        : prev
                );


                // update selected department
                setSelectedDepartment(prev => ({
                    ...prev,
                    courses: [...prev.courses, newCourse]
                }));

                if (activeTab === "course") loadData();

                setCourseName("");
            }

        } catch (err) {
            console.log(err);
        }

        setLoading(false);
    };


    if(loading){
        return <div>Loading</div>
    }



    return (

        <div className="p-6 space-y-6 bg-gray-50 min-h-screen">

            {/* HEADER */}

            <div className="flex justify-between">

                <h2 className="text-2xl font-bold">Course Management</h2>

                <div className="flex gap-3">

                    <button
                        onClick={() => setShowDeptPopup(true)}
                        className="bg-blue-600 text-white px-4 py-1.5 rounded"
                    >
                        + Department
                    </button>
                </div>

            </div>


            {/* TABS */}

            <div className="flex gap-6 border-b">
                {["department"].map(tab => (

                    <button
                        key={tab}
                        onClick={() => {
                            setActiveTab(tab);
                            setPage(1);
                        }}
                        className={`pb-2 border-b-2 ${activeTab === tab
                            ? "border-blue-600 text-blue-600"
                            : "border-transparent"}`}
                    >
                        {tab}
                    </button>

                ))}

            </div>


            {/* TABLE */}

            <div className="bg-white rounded shadow">

                {activeTab === "department" && 
                <DepartmentList
                    courses={courses}
                    BeURL={BeURL}
                    reload={loadData}
                />}
                {activeTab === "course" && <CourseList courses={courses} />}

            </div>


            {/* ================= CREATE DEPARTMENT POPUP ================= */}

            {showDeptPopup && (

                <div className="fixed inset-0 bg-black/40 flex justify-center items-center">

                    <div className="bg-white p-6 rounded w-96">

                        <h3 className="font-semibold mb-3">Create Department</h3>

                        <input
                            value={department}
                            onChange={e => setDepartment(e.target.value)}
                            className="w-full border p-2 mb-4"
                            placeholder="Department name"
                        />

                        <div className="flex justify-end gap-3">

                            <button onClick={() => setShowDeptPopup(false)}>
                                Cancel
                            </button>

                            <button
                                onClick={handleCreateDepartment}
                                className="bg-blue-600 text-white px-4 py-1 rounded"
                            >
                                Save
                            </button>

                        </div>

                    </div>

                </div>

            )}


            {/* ================= COURSE POPUP ================= */}

            {showCoursePopup && (

                <div className="fixed inset-0 bg-black/40 flex justify-center items-center">

                    <div className="bg-white p-6 rounded w-[450px]">

                        <h3 className="font-semibold mb-3">Create Course</h3>


                        {/* Department Select */}

                        <select
                            value={selectedDepartment?._id || ""}
                            onChange={e => {
                                const dep = departments.find(d => d._id === e.target.value);
                                setSelectedDepartment(dep);
                            }}
                            className="w-full border p-2 mb-4"
                        >
                            <option value="">Select Department</option>

                            {departments.map(dep => (

                                <option key={dep._id} value={dep._id}>
                                    {dep.department}
                                </option>

                            ))}

                        </select>


                        {/* Chips */}

                        {selectedDepartment && (
                            <div className="mb-4">
                                <h4 className="text-sm font-medium mb-2">Existing Courses</h4>

                                {(
                                    (selectedDepartment.courses || [])
                                        .filter(c => c && typeof c === "object") // 🔥 remove undefined/null/strings
                                        .length === 0
                                ) ? (
                                    <p className="text-sm text-gray-500">
                                        No courses yet for this department.
                                    </p>
                                ) : (
                                    <div className="flex flex-wrap gap-2 max-h-40 overflow-auto">
                                        {(selectedDepartment.courses || [])
                                            .filter(c => c && typeof c === "object") // 🔥 important
                                            .map((c) => (
                                                <button
                                                    type="button"
                                                    key={c._id || Math.random()}
                                                    onClick={() => setCourseName(c.title || c.course || c.name || "")}
                                                    className="text-sm px-3 py-1.5 border rounded-full bg-gray-100 hover:bg-gray-200"
                                                >
                                                    {c.title || c.course || c.name || "Unnamed"}
                                                </button>
                                            ))}
                                    </div>
                                )}
                            </div>
                        )}




                        {/* Input */}

                        <input
                            value={courseName}
                            onChange={e => setCourseName(e.target.value)}
                            className="w-full border p-2 mb-4"
                            placeholder="Course name"
                        />


                        {/* Buttons */}

                        <div className="flex justify-end gap-3">

                            <button onClick={() => setShowCoursePopup(false)}>
                                Cancel
                            </button>

                            <button
                                onClick={handleCreateCourse}
                                className="bg-green-600 text-white px-4 py-1 rounded"
                            >
                                Save
                            </button>

                        </div>

                    </div>

                </div>

            )}


            {/* PAGINATION */}

            <Pagination
                page={page}
                totalPages={totalPages}
                limit={limit}
                totalUsers={total}
                setPage={setPage}
                setLimit={setLimit}
            />

        </div>
    );
};
